<template>
  <section class="views">
    <headers></headers>
    <div class="views_content">
      <div class="views_banner">
        <img
          :src="
            require(`@/assets/image/hodgepodge/h5banner_${this.$i18n.locale}.jpg`)
          "
          alt=""
        />
      </div>

      <div class="views_uls">
        <div class="back_box_uls">
          <div class="backUls_box">
            <!-- <div class="ulstitle">
              <img
                :src="require('@/assets/image/hodgepodge/title1.png')"
                alt=""
              />
            </div> -->
            <div class="box_title">
              <img
                :src="require('@/assets/image/hodgepodge/title_bg.png')"
                alt=""
              />
              <div class="title" style="font-size: 0.35rem; top: -0.63rem">
                {{ $t("home.organizing_and_supporting_agencies.title") }}
              </div>
            </div>

            <div class="uls_list">
              <div class="organizersMessage">
                <!-- <img
                  :src="require('@/assets/image/hodgepodge/logo_0.jpg')"
                  alt=""
                  style="padding: 2px;"
                /> -->
                <img
                  :src="require('@/assets/image/hodgepodge/logo_1.png')"
                  alt=""
                />
                <img :src="require('@/assets/image/xiao/t4.png')" alt="" />
              </div>
              <div class="organizersMessage">
                <img
                  style="padding: 2px"
                  :src="require('@/assets/image/hodgepodge/logo_2.png')"
                  alt=""
                />
                <img
                  style="padding: 2px"
                  :src="require('@/assets/image/hodgepodge/logo_3.png')"
                  alt=""
                />
                <img
                  style="padding: 2px"
                  :src="require('@/assets/image/hodgepodge/logo_4.jpg')"
                  alt=""
                />
                <!-- <img
                  style="padding: 2px"
                  :src="require('@/assets/image/hodgepodge/logo_5.png')"
                  alt=""
                />
                <img
                  style="padding: 2px"
                  :src="require('@/assets/image/hodgepodge/logo_6.jpg')"
                  alt=""
                />
                <img
                  style="padding: 2px"
                  :src="require('@/assets/image/hodgepodge/logo_7.png')"
                  alt=""
                /> -->
              </div>

              <div class="posters_text" style="margin-top: 0.1rem">
                <ul>
                  <!-- <li>
                    <div class="posters_text_left">
                      {{
                        $t(
                          "home.organizing_and_supporting_agencies.Sponsoring_agency"
                        )
                      }}：
                    </div>
                    <div class="posters_text_right">
                      {{
                        $t(
                          "home.organizing_and_supporting_agencies.Sponsoring_agency_text"
                        )
                      }}
                    </div>
                  </li> -->
                  <li>
                    <div class="posters_text_left">
                      {{
                        $t(
                          "home.organizing_and_supporting_agencies.organizing_agency"
                        )
                      }}：
                    </div>
                    <div class="posters_text_right">
                      {{
                        $t(
                          "home.organizing_and_supporting_agencies.organizing_agency_text"
                        )
                      }}
                    </div>
                  </li>
                  <li>
                    <div class="posters_text_left">
                      {{
                        $t(
                          "home.organizing_and_supporting_agencies.co_organizing_agency"
                        )
                      }}：
                    </div>
                    <div class="posters_text_right">
                      {{
                        $t(
                          "home.organizing_and_supporting_agencies.co_organizing_agency_text"
                        )
                      }}
                    </div>
                  </li>
                  <li>
                    <div class="posters_text_left">
                      {{
                        $t(
                          "home.organizing_and_supporting_agencies.undertaking_agency"
                        )
                      }}：
                    </div>
                    <div class="posters_text_right">
                      {{
                        $t(
                          "home.organizing_and_supporting_agencies.undertaking_agency_text"
                        )
                      }}
                    </div>
                  </li>
                  <!-- <li>
                    <div class="posters_text_left">
                      {{
                        $t(
                          "home.organizing_and_supporting_agencies.supporting_agency"
                        )
                      }}：<br />
                      <span style="font-size: 0.2rem;font-weight: 400;">
                      {{
                        $t(
                          "home.organizing_and_supporting_agencies.supporting_agency_2"
                        )
                      }}
                      </span>
                    </div>
                    <div class="posters_text_right">
                      {{
                        $t(
                          "home.organizing_and_supporting_agencies.supporting_agency_text"
                        )
                      }}
                    </div>
                  </li> -->
                </ul>
              </div>
            </div>
          </div>

          <div class="backUls_box2" ref="timeSlide" v-if="false">
            <div class="timeBox">
              <div
                class="timeBox_list"
                v-for="(item, index) in tap"
                :key="index"
                :ref="`tab${index}Ref`"
              >
                <div
                  v-if="index === xuanSelect"
                  style="display: flex"
                  id="target"
                >
                  <span class="selectTime" @click="tabBut(index)"
                    >當前階段</span
                  >
                </div>

                <strong v-else>
                  <span
                    :class="select == index ? 'select' : 'selectdefault'"
                    class="timeBox_dian"
                    @click="tabBut(index)"
                  ></span>
                </strong>

                <div
                  class="timeBox_top"
                  :class="index != select ? '' : 'timeBox_topselect'"
                  @click="tabBut(index)"
                >
                  <span v-if="index != select"> {{ item.name }} </span>
                  <img
                    :src="require('@/assets/image/qp/' + (index + 1) + '.png')"
                    alt=""
                    v-else
                  />
                </div>

                <div class="timeBox_bottom" @click="tabBut(index)">
                  <strong v-html="item.tiem"> </strong>
                </div>
              </div>
            </div>
          </div>

          <div class="backUls_box3" v-if="false">
            <ul>
              <li
                v-for="(item, index) in tap"
                :key="index"
                v-if="index == select"
              >
                <div class="backUls_box3_list">
                  {{ item.content.title }}
                </div>
                <div
                  class="backUls_box3_list2"
                  v-html="item.content.value"
                ></div>
                <!-- 報名尚未開始 -->
                <!-- 在線報名 -->
                <div
                  class="backUls_box3_list3"
                  v-if="xuanSelect == select"
                  @click="baoming()"
                >
                  {{ $t("signup.title") }}
                </div>
                <!-- <div class="backUls_box3_list3" v-if="xuanSelect == select">複賽結束</div> -->
              </li>
            </ul>
          </div>
          <!-- 比赛内容及赛程时间表 -->
          <div class="backUls_box5_back"></div>
          <div class="backUls_box5">
            <div class="backUls_box5_content">
              <!-- <div class="ulstitle">
                <img
                  :src="require('@/assets/image/hodgepodge/title5.png')"
                  alt=""
                />
              </div> -->
              <div class="box_title">
                <img
                  :src="require('@/assets/image/hodgepodge/title_bg.png')"
                  alt=""
                />
                <div class="title">
                  {{ $t("home.competition_content_and_schedule.title") }}
                </div>
              </div>
              <div class="backUls_box5_nr">
                <div class="contest_content">
                  {{
                    $t(
                      "home.competition_content_and_schedule.competition_content"
                    )
                  }}
                </div>
                <div class="backUls_box5_nr_title">
                  {{ $t("home.competition_content_and_schedule.registration") }}
                </div>
                <div class="bxxq_centent">
                  <div class="bag_text">
                    {{
                      $t(
                        "home.competition_content_and_schedule.registration_period"
                      )
                    }}
                  </div>
                </div>
                <!--  -->
                <div class="backUls_box5_nr_title">
                  {{
                    $t(
                      "home.competition_content_and_schedule.preliminary_round"
                    )
                  }}
                </div>
                <div class="bxxq_centent">
                  <div class="bag_text">
                    <div style="margin-bottom: 0.05rem">
                      {{
                        $t(
                          "home.competition_content_and_schedule.preliminary_period"
                        )
                      }}
                    </div>
                    <div v-html="$t('home.competition_content_and_schedule.preliminary_round_text1')"></div>
                    <div v-html="$t('home.competition_content_and_schedule.preliminary_round_text2')"></div>
                    <div v-html="$t('home.competition_content_and_schedule.preliminary_round_text3')"></div>
                  </div>
                </div>
                <div class="backUls_box5_nr_content_2">
                  <ul>
                    <li>
                      {{
                        $t(
                          "home.competition_content_and_schedule.preliminary_review"
                        )
                      }}：{{
                        $t(
                          "home.competition_content_and_schedule.preliminary_review_period"
                        )
                      }}
                    </li>
                    <li>
                      {{
                        $t(
                          "home.competition_content_and_schedule.announce_semifinalists"
                        )
                      }}：{{
                        $t(
                          "home.competition_content_and_schedule.announce_semifinalists_date"
                        )
                      }}
                    </li>
                  </ul>
                </div>
                <!--  -->
                <div class="backUls_box5_nr_title">
                  {{ $t("home.competition_content_and_schedule.semifinal") }}
                </div>
                <div class="bxxq_centent">
                  <div class="bag_text">
                    <div v-html="$t('home.competition_content_and_schedule.semifinal_period')"></div>
                    <div v-html="$t('home.competition_content_and_schedule.semifinal_instructions')"></div>
                  </div>
                </div>
                <div class="backUls_box5_nr_content_2">
                  <ul>
                    <li>
                      {{
                        $t(
                          "home.competition_content_and_schedule.semifinal_review"
                        )
                      }}：{{
                        $t(
                          "home.competition_content_and_schedule.semifinal_review_period"
                        )
                      }}
                    </li>
                    <li>
                      {{
                        $t(
                          "home.competition_content_and_schedule.announce_finalists"
                        )
                      }}：{{
                        $t(
                          "home.competition_content_and_schedule.announce_finalists_date"
                        )
                      }}
                    </li>
                  </ul>
                </div>
                <div class="backUls_box5_nr_title">
                  {{
                    $t(
                      "home.competition_content_and_schedule.final_and_award_ceremony"
                    )
                  }}
                </div>
                <div class="bxxq_centent">
                  <div class="bag_text">
                    <div style="margin-bottom: 0.05rem">
                      {{
                        $t(
                          "home.competition_content_and_schedule.final_and_award_ceremony_date"
                        )
                      }}
                    </div>
                    <div>
                      {{
                        $t(
                          "home.competition_content_and_schedule.final_instructions"
                        )
                      }}
                    </div>
                  </div>
                </div>
                <div class="backUls_box5_nr_content_2">
                  <ul>
                    <li v-html="$t('home.competition_content_and_schedule.competition_items')"></li>
                    <li>
                      {{
                        $t(
                          "home.competition_content_and_schedule.final_social_media_voting"
                        )
                      }}<span>{{
                        $t(
                          "home.competition_content_and_schedule.final_social_media_voting_date"
                        )
                      }}</span>
                    </li>
                    <li>
                      {{
                        $t(
                          "home.competition_content_and_schedule.final_on_site_recitation_1"
                        )
                      }}<span>{{
                        $t(
                          "home.competition_content_and_schedule.final_on_site_recitation_2"
                        )
                      }}</span
                      >{{
                        $t(
                          "home.competition_content_and_schedule.final_on_site_recitation_3"
                        )
                      }}
                    </li>

                    <li>
                      {{
                        $t(
                          "home.competition_content_and_schedule.final_time_limit"
                        )
                      }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- 比赛详情  -->
          <div class="backUls_box5">
            <div class="backUls_box5_content">
              <!-- <div class="ulstitle">
                <img
                  :src="require('@/assets/image/hodgepodge/title4.png')"
                  alt=""
                />
              </div> -->
              <div class="box_title">
                <img
                  :src="require('@/assets/image/hodgepodge/title_bg.png')"
                  alt=""
                />
                <div class="title">
                  {{ $t("home.Match_schedule.title") }}
                </div>
              </div>
              <div class="backUls_box5_nr">
                <div class="backUls_box5_nr_title">
                  {{ $t("home.Match_schedule.competition_groups.title") }}
                </div>

                <div class="backUls_box4_nr_uls">
                  <div class="backUls_box4_nr_uls_list bz_color2">
                    {{
                      $t(
                        "home.Match_schedule.competition_groups.group_a_description"
                      )
                    }}<br />
                    {{
                      $t(
                        "home.Match_schedule.competition_groups.group_a_description_1"
                      )
                    }}
                    <div class="select_bz">
                      {{ $t("home.Match_schedule.competition_groups.group_a") }}
                    </div>
                  </div>
                  <div class="backUls_box4_nr_uls_list bz_color">
                    {{
                      $t(
                        "home.Match_schedule.competition_groups.group_b_description"
                      )
                    }}<br />
                    {{
                      $t(
                        "home.Match_schedule.competition_groups.group_b_description_1"
                      )
                    }}
                    <div class="select_bz">
                      {{ $t("home.Match_schedule.competition_groups.group_b") }}
                    </div>
                  </div>
                  <div class="backUls_box4_nr_uls_list bz_color2">
                    {{
                      $t(
                        "home.Match_schedule.competition_groups.group_c_description"
                      )
                    }}<br />
                    {{
                      $t(
                        "home.Match_schedule.competition_groups.group_c_description_1"
                      )
                    }}
                    <div class="select_bz">
                      {{ $t("home.Match_schedule.competition_groups.group_c") }}
                    </div>
                  </div>
                </div>
                <div class="backUls_box5_nr_content">
                  <span>{{ $t("home.participant_requirements.note") }}</span
                  >{{ $t("home.participant_requirements.additional_notes") }}
                </div>
                <!-- TODO:0401 -->
                <!-- <div class="backUls_box5_nr_title">
                  {{ $t("home.registration_competition.title") }}
                </div>
                <div class="backUls_box5_nr_content">
                  {{ $t("home.registration_competition.instruction") }}
                </div>
                <div class="backUls_box5_nr_content_2">
                  <div class="a_view" style="filter: grayscale(1);" @click="handleUploadVideo()">
                    {{ $t("achievement.upload_video") }}
                  </div>
                  <div class="a_view" style="color: #999;">{{ $t('achievement.has_ended') }}</div>
                </div> -->
                <div class="backUls_box5_nr_title">
                  {{ $t("home.competition_rules.title") }}
                </div>
                <div class="backUls_box5_nr_content">
                  {{ $t("home.competition_rules.instruction") }}
                </div>
                <div class="backUls_box5_nr_content_2">
                  <div class="a_view" @click="zhangcheng()">
                    {{ $t("home.competition_rules.button") }}
                  </div>
                </div>
                <!--  -->
                <div class="backUls_box5_nr_title">
                  {{ $t("home.competition_materials.title") }}
                </div>
                <div
                  class="backUls_box5_nr_content_2"
                  style="margin-bottom: 0.4rem"
                >
                  <div class="font_red" style="font-size: 0.28rem; margin-bottom: 10px; text-align: left;">{{ $t("home.competition_materials.group_1") }}</div>
                  <ul>
                    <li>
                      {{ $t("home.competition_materials.instruction_1") }}
                    </li>
                    <li>
                      {{ $t("home.competition_materials.instruction_2") }}
                    </li>
                    <li>
                      {{ $t("home.competition_materials.instruction_3") }}
                    </li>
                  </ul>
                </div>
                <div class="backUls_box5_nr_content_2">
                  <div class="a_view" @click="socai('https://chineserd-audio-1256597606.cos.accelerate.myqcloud.com/readingcontest/id/eda8e3ffd8ce10b372bb49ddd52291fd.pdf')">
                    {{ $t("home.competition_materials.button") }}
                  </div>
                </div>
                <div
                  class="backUls_box5_nr_content_2"
                  style="margin-bottom: 0.4rem"
                >
                  <div class="font_red" style="font-size: 0.28rem; margin-bottom: 10px; text-align: left;">{{ $t("home.competition_materials.group_2") }}</div>
                  <ul>
                    <li>
                      {{ $t("home.competition_materials.instruction_1") }}
                    </li>
                    <li>
                      {{ $t("home.competition_materials.instruction_2") }}
                    </li>
                    <li>
                      {{ $t("home.competition_materials.instruction_3") }}
                    </li>
                  </ul>
                </div>
                <div class="backUls_box5_nr_content_2">
                  <div class="a_view" @click="socai('https://chineserd-audio-1256597606.cos.accelerate.myqcloud.com/readingcontest/id/b85819ebd229ed3fd3f45034e2db6a9e.pdf')">
                    {{ $t("home.competition_materials.button") }}
                  </div>
                </div>
                 <div
                  class="backUls_box5_nr_content_2"
                  style="margin-bottom: 0.4rem"
                >
                  <div class="font_red" style="font-size: 0.28rem; margin-bottom: 10px; text-align: left;">{{ $t("home.competition_materials.group_3") }}</div>
                  <ul>
                    <li>
                      {{ $t("home.competition_materials.instruction_3") }}
                    </li>
                    <li>
                      {{ $t("home.competition_materials.instruction_4") }}
                    </li>
                    <li>
                      {{ $t("home.competition_materials.instruction_3") }}
                    </li>
                  </ul>
                </div>
                <div class="backUls_box5_nr_content_2">
                  <div class="a_view" @click="socai('https://chineserd-audio-1256597606.cos.accelerate.myqcloud.com/readingcontest/id/d3b14003c8f5baa385e7bac9cfc8afed.pdf')">
                    {{ $t("home.competition_materials.button") }}
                  </div>
                </div>
                <!--  -->
                <div class="backUls_box5_nr_title">
                  {{ $t("home.scoring_criteria.title") }}
                </div>
                <div class="backUls_box5_nr_content_2">
                  <div class="a_view" @click="onScoringStandard()">
                    {{ $t("other_pages.view_scoring_standard") }}
                  </div>
                </div>
                <div class="backUls_box5_nr_content">
                  *{{ $t("home.scoring_criteria.instruction") }}
                </div>
              </div>
            </div>
          </div>
          <!-- 参赛奖项 -->
          <div class="backUls_box5">
            <div class="backUls_box5_content">
              <!-- <div class="ulstitle">
                <img
                  :src="require('@/assets/image/hodgepodge/title6.png')"
                  alt=""
                />
              </div> -->
              <div class="box_title">
                <img
                  :src="require('@/assets/image/hodgepodge/title_bg.png')"
                  alt=""
                />
                <div class="title">
                  {{ $t("home.competition_phases.competition_award") }}
                </div>
              </div>
              <div class="tables">
                <div style="overflow-x: auto">
                  <table>
                    <thead>
                      <tr>
                        <th style="width: 18%">
                          <strong>{{
                            $t("home.competition_phases.title")
                          }}</strong>
                        </th>
                        <th style="width: 18%">
                          <strong>{{
                            $t("home.competition_phases.awards")
                          }}</strong>
                        </th>
                        <th>
                          <strong>{{
                            $t("home.competition_phases.prizes")
                          }}</strong>
                        </th>
                        <th style="width: 30%">
                          <strong>{{
                            $t("home.competition_phases.selection_method")
                          }}</strong>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>{{
                            $t("home.competition_phases.preliminary_phase")
                          }}</strong>
                        </td>
                        <td>
                          <strong>{{
                            $t(
                              "home.competition_phases.participation_certificate"
                            )
                          }}</strong>
                        </td>
                        <td>
                          <strong>{{
                            $t(
                              "home.competition_phases.electronic_participation_certificate"
                            )
                          }}</strong>
                        </td>
                        <td>
                          <strong>{{
                            $t(
                              "home.competition_phases.submit_recitation_audio"
                            )
                          }}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{{
                            $t("home.competition_phases.semifinal_phase")
                          }}</strong>
                        </td>
                        <td>
                          <strong>{{
                            $t("home.competition_phases.semifinal_certificate")
                          }}</strong>
                        </td>
                        <td>
                          <strong>{{
                            $t(
                              "home.competition_phases.electronic_semifinal_certificate"
                            )
                          }}</strong>
                        </td>
                        <td>
                          <strong>{{
                            $t("home.competition_phases.top_100_per_group")
                          }}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td rowspan="6">
                          <strong>{{
                            $t("home.competition_phases.final_phase")
                          }}</strong>
                        </td>
                        <td>
                          <strong>{{
                            $t("home.competition_phases.first_prize")
                          }}</strong>
                        </td>
                        <td style="text-align: left">
                          {{ $t("home.competition_phases.first_prize_amount_1")
                          }}<br />
                          {{ $t("home.competition_phases.first_prize_amount_2")
                          }}<br />
                          {{ $t("home.competition_phases.first_prize_amount_3")
                          }}<br />
                          <!-- <span>{{
                            $t("home.competition_phases.first_prize_amount_3_1")
                          }}</span
                          >{{
                            $t(
                              "home.competition_phases.first_prize_amount_3_1_text"
                            )
                          }}<br /> -->
                          <span>{{
                            $t("home.competition_phases.first_prize_amount_3_2")
                          }}</span
                          >{{
                            $t(
                              "home.competition_phases.first_prize_amount_3_2_text"
                            )
                          }}<br />
                          <span>{{
                            $t("home.competition_phases.first_prize_amount_3_3")
                          }}</span
                          >{{
                            $t(
                              "home.competition_phases.first_prize_amount_3_3_text"
                            )
                          }}
                        </td>

                        <td rowspan="6">
                          <strong>{{
                            $t("home.competition_phases.on_site_competition")
                          }}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{{
                            $t("home.competition_phases.second_prize")
                          }}</strong>
                        </td>
                        <td style="text-align: left">
                          {{
                            $t("home.competition_phases.second_prize_amount_1")
                          }}<br />
                          {{
                            $t("home.competition_phases.second_prize_amount_2")
                          }}<br />
                          {{
                            $t("home.competition_phases.second_prize_amount_3")
                          }}<br />
                          <!-- <span>{{
                            $t(
                              "home.competition_phases.second_prize_amount_3_1"
                            )
                          }}</span
                          >{{
                            $t(
                              "home.competition_phases.second_prize_amount_3_1_text"
                            )
                          }}<br /> -->
                          <span>{{
                            $t(
                              "home.competition_phases.second_prize_amount_3_2"
                            )
                          }}</span
                          >{{
                            $t(
                              "home.competition_phases.second_prize_amount_3_2_text"
                            )
                          }}<br />
                          <span>{{
                            $t(
                              "home.competition_phases.second_prize_amount_3_3"
                            )
                          }}</span
                          >{{
                            $t(
                              "home.competition_phases.second_prize_amount_3_3_text"
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{{
                            $t("home.competition_phases.third_prize")
                          }}</strong>
                        </td>
                        <td style="text-align: left">
                          {{ $t("home.competition_phases.third_prize_amount_1")
                          }}<br />
                          {{ $t("home.competition_phases.third_prize_amount_2")
                          }}<br />
                          {{ $t("home.competition_phases.third_prize_amount_3")
                          }}<br />
                          <!-- <span>{{
                            $t("home.competition_phases.third_prize_amount_3_1")
                          }}</span
                          >{{
                            $t(
                              "home.competition_phases.third_prize_amount_3_1_text"
                            )
                          }}<br /> -->
                          <span>{{
                            $t("home.competition_phases.third_prize_amount_3_2")
                          }}</span
                          >{{
                            $t(
                              "home.competition_phases.third_prize_amount_3_2_text"
                            )
                          }}<br />
                          <span>{{
                            $t("home.competition_phases.third_prize_amount_3_3")
                          }}</span
                          >{{
                            $t(
                              "home.competition_phases.third_prize_amount_3_3_text"
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{{
                            $t("home.competition_phases.most_popular_award")
                          }}</strong>
                        </td>
                        <td style="text-align: left">
                          {{
                            $t(
                              "home.competition_phases.most_popular_award_amount_1"
                            )
                          }}<br />
                          {{
                            $t(
                              "home.competition_phases.most_popular_award_amount_2"
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{{
                            $t("home.competition_phases.creative_award")
                          }}</strong>
                        </td>
                        <td style="text-align: left">
                          {{
                            $t(
                              "home.competition_phases.creative_award_amount_1"
                            )
                          }}<br />
                          {{
                            $t(
                              "home.competition_phases.creative_award_amount_2"
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{{
                            $t("home.competition_phases.encouragement_award")
                          }}</strong>
                        </td>
                        <td style="text-align: left">
                          {{
                            $t(
                              "home.competition_phases.encouragement_award_amount_1"
                            )
                          }}<br />
                          {{
                            $t(
                              "home.competition_phases.encouragement_award_amount_2"
                            )
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  style="
                    margin-top: 0.15rem;
                    line-height: 0.4rem;
                    text-align: left;
                    font-size: 0.25rem;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #e80202;
                    padding: 0.2rem;
                  "
                >
                  *{{ $t("home.competition_phases.final_disclaimer") }}
                </div>
              </div>
            </div>
          </div>

          <!-- 占位 -->
          <div class="backUls_box6"></div>
        </div>
      </div>

      <!-- TODO: 0307 -->
      <div class="fontBottom"  @click="baoming()">
        <span>{{ $t("signup.title") }}</span>
      </div>
      <!-- TODO: 0401 -->
      <!-- <div class="fontBottom" style="filter: grayscale(1);" @click="handleUploadVideo()">
        <span>{{ $t("achievement.upload_video") }}</span>
      </div> -->
      <!-- <<div class="fontBottom">
        <span>複賽結束</span>
      </div> -->
    </div>
    <!-- 复赛资料视频上传-->
    <van-popup
      v-model="datumZZC"
      :close-on-click-overlay="false"
      :closeable="true"
      :round="true"
      :lock-scroll="false"
      :style="{ width: '90%'}"
    >
      <div class="datumBox">
        <div class="titleH1">
          <div class="left_icon">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="title">{{ $t('achievement.upload_video_text') }}</div>
          <div class="right_icon">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <div class="stepBox">
          <div class="stepUls">
            <div
              class="xian"
              :class="stepActive >= 1 ? 'active2' : 'active'"
            ></div>
            <div
              class="xian"
              :class="stepActive >= 2 ? 'active2' : 'active'"
            ></div>
          </div>

          <ul>
            <li
              v-for="(item, index) in 3"
              :class="stepActive >= index ? 'active' : ''"
              :key="index"
            ></li>
          </ul>
        </div>
        <div class="stepText">
          <div :class="stepActive >= 0 ? 'active' : ''">{{ $t("achievement.login") }}</div>
          <div :class="stepActive >= 1 ? 'active' : ''">{{ $t("achievement.improve_info") }}</div>
          <div :class="stepActive >= 2 ? 'active' : ''">{{ $t("achievement.upload_video") }}</div>
        </div>

        <div class="datumCentent" v-if="stepActive == 0">
          <div class="tab">
            <div class="promptInput">
              <CountryCodeSelector
                :searchbar="false"
                :countryCode.sync="prefix"
                style="width: 80px; margin-right: 10px"
              ></CountryCodeSelector>
              <input
                type="text"
                :placeholder="$t('achievement.enter_tel_join')"
                value=""
                v-model.trim="from.phone"
              />
            </div>
            <div class="promptInput">
              <input
                :placeholder="$t('achievement.enter_name')"
                v-model="from.name"
              />
            </div>
          </div>
          <div class="tabTis">
            {{ $t("achievement.submit_tips") }}
            <a href="http://wa.me/6281334941415" target="_blank" @click="lianxi"
              ><img src="@/assets/image/fusai/whatsapp.png"
            /></a>
          </div>
          <div class="but" @click="datumActiveBut ? datumBut(0) : ''">
            {{ $t("achievement.next_step") }}
          </div>
        </div>

        <div class="datumCentent" v-if="stepActive == 1">
          <div class="tab">
            <div class="prompt">
              {{  $t('achievement.certificate_upload') }}
              <span>&nbsp;{{  $t('achievement.upload_certificate_text') }}</span>
            </div>
            <div class="promptInput3" style="margin: 10px 0 15px;">
              <uploaderCent
                @uploaderChange="uploaderImageChange"
                accept="image/*"
                :uploadText="$t('achievement.click_upload')"
                logoaAtive="0"
              ></uploaderCent>
            </div>

            <div class="cell-item">
              <div class="promptInput">
                <input
                  :placeholder="$t('achievement.enter_birthday')"
                  :value="from.birthday"
                  readonly
                />
                <span class="right-btn" @click="showDatePicker = true">{{ $t('achievement.enter_birthday') }}</span>
              </div>
              <div class="tips">{{ $t('achievement.enter_birthday_tips') }}</div>
            </div>
            <div class="cell-item">
              <div class="promptInput">
                <input
                  v-model="from.birthplace"
                  :placeholder="$t('achievement.enter_birthplace')"
                />
              </div>
              <div class="tips">{{ $t('achievement.enter_birthplace_tips') }}</div>
            </div>
            <div class="cell-item">
              <div class="promptInput">
                <input
                  :placeholder="$t('achievement.enter_instructor')"
                  v-model="from.instructor"
                />
              </div>
              <div class="tips">{{ $t('achievement.enter_instructor_tips') }}</div>
            </div>
          </div>

          <div class="tabTis">
            {{ $t('achievement.submit_tips') }}
            <a href="http://wa.me/6281334941415" target="_blank" @click="lianxi"
              ><img src="@/assets/image/fusai/whatsapp.png"
            /></a>
          </div>
          <div class="but" @click="datumBut(1)">{{ $t('achievement.next_step') }}</div>
          <!-- <div class="but2" @click="getBack()">返回上一步</div> -->
        </div>

        <div class="datumCentent" v-if="stepActive == 2">
          <div class="tab">
            <div class="promptInput3">
              <uploaderCent
                @uploaderChange="uploaderVideoChange"
                accept="video/*"
                :uploadText="$t('achievement.click_upload_video')"
                v-if="wonderful == false"
                logoaAtive="1"
              ></uploaderCent>
              <!-- 上傳影片成功后顯示預覽按鈕 -->
              <div class="videoYulan" v-if="videoYL">
                <div class="guanbu" @click="videoYLBut">X</div>
                <video controls :autoplay="true" :src="videoUrl"></video>
              </div>
              <div
                class="videoYulan2"
                style="cursor: pointer"
                v-if="from.video != null && wonderful == false"
                @click="videoYLBut"
              >
                <span style="color: #000000 !important; margin-right: 0.1rem"
                  >{{ $t('achievement.upload_video_success') }}</span
                >{{ $t('achievement.click_view_video') }}
              </div>
              <div class="wonderful" v-if="wonderful == true">
                <img src="@/assets/image/fusai/ludui.png" />
                {{ $t('achievement.been_success_wait')}}
              </div>
            </div>
          </div>
          <div class="tabTis" v-if="wonderful == false">
            {{ $t('achievement.submit_tips') }}
            <a href="http://wa.me/6281334941415" target="_blank" @click="lianxi"
              ><img src="@/assets/image/fusai/whatsapp.png"
            /></a>
          </div>
          <div
            class="but"
            v-if="wonderful == false"
            @click="datumActiveBut ? submit() : ''"
          >
          {{ $t('achievement.submit')}}
          </div>
          <div class="but" v-if="wonderful == true" @click="wonderfulBut">
            {{ $t('achievement.ok')}}
          </div>
          <!-- <div class="but2" v-if="wonderful==false" @click="getBack()">返回上一步</div> -->
        </div>
      </div>
    </van-popup>
    <!-- 未入圍/成功入園 -->
    <van-popup v-model="newShortZZC" :round="true" :lock-scroll="false" :style="{ width: '80%'}">
      <div class="newShortBox">
        <div class="list" v-if="newShortActive == 1">
          <!-- <div class="lis lisCenten"> <van-image width="1.49rem" :src="require('@/assets/image/fusai/yes.png')" /> </div> -->
          <div class="ulst">
            <ul>
              <li>{{ $t('achievement.name') }}</li>
              <li>{{ $t('achievement.group') }}</li>
              <li>{{ $t('achievement.score') }}</li>
            </ul>
            <ul>
              <li>
                {{ userObj.studentName == null ? "" : userObj.studentName }}
              </li>
              <li>
                {{
                  userObj.competitionGroup == null
                    ? ""
                    : userObj.competitionGroup
                }}
              </li>
              <li>{{ userObj.score == null ? "" : userObj.score }}</li>
            </ul>
          </div>
          <div class="lis lisText" v-html="$t('achievement.join_success')"></div>
          <!-- <div class="but" @click="handelGuide">點擊查看複賽指引</div> -->
        </div>

        <div class="list" v-if="newShortActive == 2">
          <div class="ulst">
            <ul>
              <li>{{ $t('achievement.name') }}</li>
              <li>{{ $t('achievement.group') }}</li>
              <li>{{ $t('achievement.score') }}</li>
            </ul>
            <ul>
              <li>
                {{ userObj.studentName == null ? "" : userObj.studentName }}
              </li>
              <li>
                {{
                  userObj.competitionGroup == null
                    ? ""
                    : userObj.competitionGroup
                }}
              </li>
              <li>{{ userObj.score == null ? "" : userObj.score }}</li>
            </ul>
          </div>
          <div class="lis lisText" v-html="$t('achievement.join_fail')"></div>
        </div>
      </div>
    </van-popup>
    <van-dialog
      v-model="showGuide"
      :show-close-button="false"
      :close-on-click-overlay="true"
      width="80%"
      z-index="99999"
      :confirm-button-text="$t('other_pages.close')"
    > 
      <div class="image-container" v-if="showType == 'img'">
        <van-image
          width="100%"
          :src="require('@/assets/image/H5_guide.jpg')"
          fit="contain"
        />
      </div>
      <div class="image-container" v-if="showType == 'video'">
        <video
          height="99%"
          controls
          :autoplay="true"
          src="https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2024-04/1d48744a1c3f5f6dfb8f0a95c4bc66cd.mp4"
        ></video>
      </div>
    </van-dialog>

    <van-dialog v-model="showDatePicker"
      :title="$t('achievement.enter_birthday')"
      :confirmButtonText="$t('other_pages.confirm')"
      @confirm="confirmDate"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        :show-toolbar="false"
        @cancel="showDatePicker = false"
      />
    </van-dialog>
  </section>
</template>

<script>
import headers from "@/components/header/h_header";
import publics from "@/mixin/public_mixin";
import home from "@/mixin/home_mixin";
import uploaderCent from "@/components/uploaderBox/index.vue";
import CountryCodeSelector from "@/components/CountryCodeSelector";
export default {
  name: "views",
  data() {
    return {
      tap: [
        {
          name: "正式報名",
          tiem: `4月16日<br/> 至 <br/>5月21日 22:00`,
          select: true,
          xuanSelect: true,
          content: {
            title: "正式報名",
            value: "官方活動網站或中文路APP：ChineseRd Plus",
          },
        },
        {
          name: "初賽",
          tiem: `4月16日<br/> 至 <br/>5月21日 23:59`,
          select: false,
          xuanSelect: false,
          content: {
            title: "中文路APP",
            value: `通過中文路App進行普通話語音測試，每人共有5次測試機會，將自動選擇最高分的1次參與評選，各組別分數排名最多<span style="color:red;">前100名</span>將獲得入圍複賽資格，參與複賽影片錄製。`,
          },
        },
        {
          name: "公佈複賽入圍名單",
          tiem: `5月22日`,
          select: false,
          xuanSelect: false,
          content: {
            title: "官方活動網站公佈名單或登入中文路App查詢個人入圍情況",
            value: "請留意電郵或短信提醒並查閱入圍結果。",
          },
        },
        {
          name: "複賽",
          tiem: `5月22日<br/> 至 <br/>6月6日 23:59`,
          select: false,
          xuanSelect: false,
          content: {
            title: "官方活動網站或中文路APP",
            value: `
            複賽入圍學生須使用當前組別官方指定誦材，並進行影片錄製，可通過官方活動網站或中文路App提交複賽影片，複賽各組別分數排名<span style="color:red;">前10名</span>將獲得進入決賽資格。`,
          },
        },
        {
          name: "公佈決賽入圍名單",
          tiem: `6月15日`,
          select: false,
          xuanSelect: false,
          content: {
            title: "官方活動網站公佈名單",
            value: "請留意電郵或短信提醒並查閱入圍結果。",
          },
        },
        {
          name: "決賽暨頒獎典禮",
          tiem: `6月29日`,
          select: false,
          xuanSelect: false,
          content: {
            title: "（請留意主辦方最新公佈的安排為準）",
            value: "將於線下場所進行現場對決比賽，上半場決賽，下半場頒獎典禮。",
          },
        },
      ],
      select: 0,
      xuanSelect: 0, //当前阶段
      datumZZC: false, // 上传视频弹窗控制
      stepActive: 0, //控制流程  很重要这玩意勿搞错  参数0 1 2  表示三步骤
      datumActiveBut: true, //防止連續點擊
      wonderful: false, //成功
      videoYL: false, //預覽
      chooseFrom: 0, //驗證
      newShortZZC: false, //入圍 彈窗
      newShortActive: 1, //1是成功  2是失敗
      choose: 0, //查詢的下標
      from: {
        name: null, //名字
        phone: null, //手机
        certificate: null,
        birthday: null, //生日
        birthplace: null, //生日
        instructor: null, //生日
        video: null, //视频
      },
      finalistsBut: true, //防止連續點擊
      userObj: {
        competitionGroup: 1, //組別
        score: null, //分數
        studentName: null, //名字
      },
      prefix: 62,
      showGuide: false,
      showType: "",
      showDatePicker: false,
      minDate: new Date(1970, 0, 1),
      maxDate: new Date(),
      currentDate: new Date()
    };
  },
  computed: {},
  components: {
    headers,
    uploaderCent,
    CountryCodeSelector,
  },
  mixins: [publics, home],
  watch: {},
  created() {},
  mounted() {
    if (this.$route.query.uploadVideo === 'true') {
      this.datumZZC = true
      this.$router.replace({ query: { uploadVideo: false } })
    }
    this.$nextTick(() => {
      setTimeout(() => {
        this.initScroll(); // 时间轴居中
      }, 1500);
    });
  },
  methods: {
    uploaderImageChange(e) {
      this.from.certificate = e.vaidoUrl
      this.$toast.clear()
    },
    confirmDate() {
      this.from.birthday = this.formatDate(this.currentDate)
    },
    formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = `0${d.getMonth() + 1}`.slice(-2);
      const day = `0${d.getDate()}`.slice(-2);
      return `${year}-${month}-${day}`;
    },
    handleShowGuide(type) {
      this.showGuide = true;
      this.showType = type;
    },
    handleUploadVideo() {
      // TODO: 0328
      this.$dialog
      .alert({
        title: '',
        message: this.$t('achievement.semi_ended'),
        confirmButtonText: this.$t('other_pages.confirm')
      })
      .then(() => {
        // on close
      })
      return;
      this.datumZZC = true;
    },
    datumYZ(e) {
      this.chooseFrom = e;
    },
    lianxi() {
      // 联系我们
      // window.location.href = 'http://wa.me/6281334941415';
      window.open("http://wa.me/6281334941415");
    },
    // 點擊上傳下一步
    datumBut(e) {
      switch (e) {
        case 0:
          // 下一步 驗證信息
          this.getUser();
          // this.stepActive = 2;
          break;
        case 1:
          if (!this.from.certificate) {
            this.$toast(this.$t('achievement.upload_certificate') + " !")
            return
          }  

          if (!this.from.birthday) {
            this.$toast(this.$t('achievement.enter_birthday'));
            return;
          }

          if (!this.from.birthplace) {
            this.$toast(this.$t('achievement.enter_birthplace'));
            return;
          }

          this.stepActive = 2;
          break;
        case 2:
          // 提交啦
          break;
        case 3:
      }
    },
    // 驗證信息
    getUser() {
      let params = {
        studentName: this.from.name,
        prefix: this.prefix,
        phone: this.from.phone,
      };

      if (params.studentName == "" || params.studentName == null) {
        this.$toast(this.$t("achievement.enter_name") + " !");
        return;
      }
      // 手機
      if (params.phone == "" || params.phone == null) {
        this.$toast(this.$t("achievement.enter_tel_join") + " !");
        return;
      }

      if (!this.validator_phone(params.phone)) {
        this.$toast(this.$t("achievement.phone_format_err") + " !");
        return;
      }

      this.datumActiveBut = false;
      this.$toast.loading();
      this.$axios
        .post(this.$api.getPersonInfo, params)
        .then((response) => {
          this.datumActiveBut = true;
          this.$toast.clear();
          const { data, code, msg } = response.data;
          if (code == 500) {
            this.$toast.fail(msg);
            return;
          }
          const {
            competitionGroup,
            score,
            studentName,
            shortlisted,
          } = data;
          if (code == 0) {
            this.userObj.competitionGroup = competitionGroup; //組別
            this.userObj.score = score; //分數
            this.userObj.studentName = studentName; //名字

            if (shortlisted) {
              this.stepActive = 1;
            } else {
              // 失敗
              // this.datumZZC = false; //复赛资料上传弹窗
              this.stepActive = 0; //控制流程  很重要这玩意勿搞错  参数0 1 2  表示三步骤
              this.newShortZZC = true; //入圍 彈窗
              this.newShortActive = 2; //1是成功  2是失敗
            }
          }
        })
        .catch((error) => {
          this.$toast.clear();
          this.datumActiveBut = true;
          //请求失败
          this.$toast.fail("error");
        });
    },
    validator_email(val) {
      const email = val.trim();
      return /^[A-Za-z0-9]+([_\-\.][A-Za-z0-9]+)*@([A-Za-z0-9\-\_]+\.)+[A-Za-z]{2,6}$/.test(
        email
      );
    },
    validator_phone(val) {
      const phone = val.trim();
      return /^[0-9]*$/.test(phone);
    },
    // 視頻
    uploaderVideoChange(e) {
      // console.log('视频', e);
      this.from.video = e.vaidoUrl;
      this.videoUrl = e.vaidoUrl;
      // this.videoUrl = e.yuanVideo;
      this.$toast.clear();
    },
    // 視頻預覽
    videoYLBut() {
      this.videoYL = !this.videoYL;
    },
    //返回上一步
    // getBack() {
    // 	this.stepActive--;
    //   this.from.video = null
    //   this.videoUrl = null
    // },
    // 提交
    submit() {
      const { phone, name, video, certificate, birthday, birthplace, instructor } = this.from;
      let params = {
        personalID: certificate,
        studentName: name, //学生名字
        phone, //手機號
        birthday,
        birthplace,
        instructor,
        // videoUrl: 'https://materialv3-1256597606.cos.ap-hongkong.myqc…/dev/2023-09/eb816d9e21e9f18fccea6c461ba2c3dc.mp4', //学生上传的视频内容
        videoUrl: video, //学生上传的视频内容
      };

      if (params.videoUrl == null || params.videoUrl == "") {
        this.$toast(this.$t("achievement.upload_video_tips") + " !");
        return;
      }

      this.datumActiveBut = false;
      this.$toast.loading({
        message: this.$t("achievement.subming"),
        duration: 0,
        forbidClick: true,
      });

      // 本地測試專用
      // this.$axios({
      // 	url: '/api/statistics/competition/update',
      // 	method: 'post',
      // 	data: params
      // })

      // 正式發包
      this.$axios
        .post(this.$api.update, params)
        .then((response) => {
          this.datumActiveBut = true;
          // console.log(response);
          if (response.data.code == 500) {
            this.$toast.fail(response.data.msg);
          }
          if (response.data.code == 0) {
            this.$toast.clear();
            this.wonderful = true;
          }
        })
        .catch((error) => {
          this.datumActiveBut = true;
          //请求失败
          this.$toast.fail("error");
          console.log(error);
        });
    },
    // 上傳成功  相當於初始化
    wonderfulBut() {
      this.wonderful = false;
      this.datumZZC = false;
      this.stepActive = 0;
      this.from = {
        name: null, //名字
        phone: null, //手机
        birthday: null, //生日
        birthplace: null, //生日
        instructor: null, //生日
        video: null, //视频
      };
    },
    zhangcheng() {
      window.open(this.constitutionUrl, "_blank");
      // this.$router.push("/constitution");

      // this.$toast.loading({
      // 	message: '獲取地址中...',
      // 	forbidClick: true,
      // 	duration: 0
      // });

      // let url = 'https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2023-07/fe62588d996ef0818389f65f4192086c.pdf';
      // this.$axios({
      //   url: url,
      //   method: 'get',
      //   responseType: 'blob',
      // })
      // .then(response => {
      //   this.$toast.clear();
      //   this.$toast.success('開始下載');
      //   // 将文件流转化为 Blob 对象，并创建 a 标签进行下载
      //   const blob = new Blob([response.data], { type: 'application/pdf' });
      //   const downloadElement = document.createElement('a');
      //   const href = window.URL.createObjectURL(blob); // 创建下载链接
      //   downloadElement.href = href;
      //   downloadElement.download = 'zhangcheng.pdf'; // 文件名
      //   document.body.appendChild(downloadElement);
      //   downloadElement.click(); // 下载
      //   document.body.removeChild(downloadElement); // 下载完成后移除元素
      //   window.URL.revokeObjectURL(href); // 释放占用的内存空间
      // }).catch(error => {
      //   this.$toast.clear();
      //   console.error(error); // 处理异常情况
      // });
    },
    baoming() {
      // TODO: 0307
      // this.$dialog
      // .alert({
      //   title: '',
      //   message: this.$t('achievement.has_ended'),
      //   confirmButtonText: this.$t('other_pages.confirm'),
      // })
      // .then(() => {
      //   // on close
      // })
      // return;
      this.$router.push("/signup");
    },
    socai(url) {
      window.open(url, "_blank");
    },
    onScoringStandard() {
      window.open(this.scoringStandardUrl, "_blank");
    },
    tabBut(e) {
      this.select = e;
      // 触发滑动方法
      this.scrollLeftTo(e);
    },
    initScroll() {
      // let target = document.getElementById('target')
      const nav = this.$refs.timeSlide;
      // 计算位移偏差
      // const to =  (nav.offsetWidth - target.offsetWidth) / 2 - target.offsetLeft
      // const to =  nav.offsetWidth + target.offsetWidth + target.offsetLeft

      // nav.scrollLeft = 0
    },
    // 滑动
    scrollLeftTo(name) {
      const ref = `tab${name}Ref`;
      const nav = this.$refs.timeSlide;
      // console.log("额:", this.$refs.timeSlide.offsetWidth);
      const title = this.$refs[ref][0];
      // 计算位移偏差
      const to = title.offsetLeft - (nav.offsetWidth - title.offsetWidth) / 2;
      nav.scrollLeft = to;
    },
  },
};
</script>

<style lang="scss" scoped>
.views {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: linear-gradient(225deg, #ff8310 0%, #fe840f 100%);

  .views_content {
    width: 100%;
    height: calc(100% - 0.92rem);
    overflow-x: hidden;

    .views_banner {
      width: 100%;
      display: grid;

      img {
        width: 100%;
      }
    }

    .views_uls {
      width: 100%;
      background: url("~@/assets/image/hodgepodge/back.png") no-repeat;
      background-size: 100%;
      min-height: 5rem;

      .back_box_uls {
        width: 100%;

        .backUls_box {
          width: 100%;
          padding: 0.32rem;
          box-sizing: border-box;

          .ulstitle {
            width: 6.0228rem;
            height: 0.43rem;
            margin: auto;

            img {
              width: 100%;
              margin-top: -0.85rem;
            }

            .title {
              position: absolute;
              top: -0.32rem;
              left: 50%;
              transform: translateX(-50%);
              font-size: 0.3rem;
              font-weight: bold;
              color: #fff;
              // text-shadow: 0rem .04rem .04rem rgba(0, 0, 0, 0.25);
              text-shadow: -0.01rem -0.01rem 0 #ff782f,
                0.01rem -0.01rem 0 #ff782f, -0.01rem 0.01rem 0 #ff782f,
                0.01rem 0.01rem 0 #ff782f;
            }
          }

          .uls_list {
            width: 100%;
            padding: 0.32rem;
            padding-bottom: 1rem;
            box-sizing: border-box;
            background: #fff;
            box-shadow: 0rem 0.08rem 0.12rem 0rem rgba(0, 0, 0, 0.05);
            border-radius: 0.3rem;
            position: relative;

            .organizersMessage {
              width: 100%;
              display: flex;
              justify-content: center;
              // 可以换行
              flex-wrap: wrap;
              // margin-bottom: 0.4rem;

              img {
                width: 1.15rem;
                height: 0.58rem;
                background: #fff;
                border-radius: 0.1rem;
                object-fit: contain;
                box-shadow: 0rem 0.08rem 0.08rem 0rem rgba(0, 0, 0, 0.03);
                margin: 0 0.1rem;
                box-sizing: border-box;
                margin-bottom: 0.3rem;
              }
            }

            .posters_text {
              width: 100%;

              ul {
                width: 100%;

                li {
                  width: 100%;
                  margin-bottom: 0.16rem;
                  display: flex;
                  font-size: 0.24rem;
                  line-height: 0.4rem;

                  .posters_text_left {
                    width: 2.1rem;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #333333;
                    text-align: left;
                    line-height: 1.2;
                  }

                  .posters_text_right {
                    width: calc(100% - 2.1rem);
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    text-align: left;
                    line-height: 1.2;
                  }
                }
              }
            }
          }
        }

        .backUls_box2::-webkit-scrollbar {
          display: none;
        }

        .backUls_box2 {
          width: 100%;
          min-height: 3rem;
          margin-top: -22%;
          background: url("~@/assets/image/hodgepodge/back2.png") no-repeat;
          background-size: 100%;
          position: relative;
          padding-top: 2.6rem;
          // padding-bottom: 0.86rem;
          padding-left: 0.32rem;
          box-sizing: border-box;
          overflow-x: scroll;

          .timeBox {
            width: 100%;
            height: 0.08rem;
            // background: linear-gradient(270deg, rgba(255,255,255,0) 0%, #FFFFFF 22%, #FFFFFF 80%, rgba(255,255,255,0) 100%);
            border-radius: 0.52rem;
            white-space: nowrap;
            // display: flex;
            display: inline-flex;
            margin-bottom: 1rem;

            .timeBox_list {
              width: 2.54rem;
              height: 100%;
              background: #ffffff;
              position: relative;
              flex: 0 0 auto;
              display: flex;
              justify-content: center;
              align-items: center;

              .timeBox_dian {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                border: 0.04rem solid #ffffff;
                border-radius: 50%;
              }

              .select {
                width: 0.32rem;
                height: 0.32rem;
                background: #ffe600;
              }

              .selectdefault {
                width: 0.2rem;
                height: 0.2rem;
                background: #ffffff;
              }

              .selectTime {
                padding: 0.1rem 0.3rem;
                font-size: 0.24rem;
                text-align: center;
                box-sizing: border-box;
                background: #f78040;
                border-radius: 0.5rem;
                border: 0.01rem solid #fff;
                color: #fff;
              }

              .timeBox_topselect {
                // border-image-source: url("~@/assets/image/icon/qipao2.png");
                // border-image-slice: 116 76 76 76;
                // border-image-width: 1.1rem 0.8rem 0.8rem 0.8rem;
                // border-width: 0.8rem;
                // padding: 0.07rem 0.17rem 0.14rem 0.17rem;
                // box-sizing: border-box;
                // font-size: 0.28rem;
                // font-family: PingFang SC-Semibold, PingFang SC;
                // font-weight: 600;
                // color: #903300 !important;
                // align-items:center !important;
              }

              .timeBox_top {
                width: 100%;
                height: 1rem;
                // background-color: red;
                position: absolute;
                bottom: 0.4rem;
                left: 0;

                display: flex;
                justify-content: space-around;
                align-content: flex-end;
                flex-wrap: nowrap;
                align-items: flex-end;
                font-size: 0.28rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #ffffff;

                img {
                  width: 100%;
                  object-fit: contain;
                }
              }

              .timeBox_bottom {
                width: 100%;
                height: 1rem;
                // background-color: red;
                position: absolute;
                top: 0.4rem;
                left: 0;

                display: flex;
                justify-content: space-around;
                font-size: 0.2rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                line-height: 0.35rem;
              }
            }

            .timeBox_list:first-child {
              background: linear-gradient(
                270deg,
                #ffffff 80%,
                #ffffff 22%,
                #ffffff 80%,
                rgba(255, 255, 255, 0) 100%
              );
            }

            .timeBox_list:last-child {
              background: linear-gradient(
                270deg,
                rgba(255, 255, 255, 0) 0%,
                #ffffff 80%,
                #ffffff 80%,
                #ffffff 100%
              );
            }
          }
        }

        .backUls_box3 {
          width: 100%;
          background-color: #f78041;

          ul {
            width: 100%;
            display: flex;
            padding: 0.32rem;
            box-sizing: border-box;

            li {
              padding: 0.24rem;
              box-sizing: border-box;
              width: 100%;
              min-height: 2.72rem;
              background: #ffffff;
              box-shadow: 0rem 0.08rem 0.12rem 0rem rgba(0, 0, 0, 0.05);
              border-radius: 0.24rem;
              text-align: left;
              position: relative;

              .backUls_box3_list {
                width: 100%;
                font-size: 0.32rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #f97226;
                line-height: 0.43rem;
              }

              .backUls_box3_list2 {
                width: 100%;
                font-size: 0.28rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 0.28rem;
                margin-top: 0.08rem;
                line-height: 0.44rem;

                span {
                  font-size: 0.28rem;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #666666;
                  line-height: 0.28rem;
                  margin-top: 0.08rem;
                  line-height: 0.44rem;
                }
              }

              .backUls_box3_list3 {
                position: absolute;
                bottom: 0.24rem;
                right: 0.24rem;
                padding: 0.08rem 0.24rem;
                box-sizing: border-box;
                border-radius: 1.6rem;
                font-size: 0.24rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #ffffff;
                line-height: 0.28rem;

                background: url("~@/assets/image/hodgepodge/buttom.png")
                  no-repeat;
                background-size: 100% 100%;
                // background:#D0D0D0;
                box-shadow: 0rem 0.04rem 0.09rem 0rem rgba(208, 208, 208, 0.4);
              }
            }
          }
        }

        .backUls_box4 {
          width: 100%;
          padding: 0.32rem;
          padding-top: 1.32rem;
          box-sizing: border-box;
          background: #ff782f;

          .backUls_box4_content {
            width: 100%;
            // height: 8.72rem;
            // background: url('~@/assets/image/hodgepodge/back3.png') no-repeat;
            background-size: 100%;
            width: 100%;
            padding: 0.32rem;
            padding-top: 0rem;
            box-sizing: border-box;
            border-image-source: url("~@/assets/image/hodgepodge/back3.png");
            border-image-slice: 84 10 10 10;
            border-image-width: 0.6rem 0.12rem 0.12rem 0.12rem;
            border-width: 0.12rem;

            .ulstitle {
              width: 6.0228rem;
              height: 0.43rem;
              margin: auto;

              img {
                width: 100%;
                margin-top: -0.85rem;
              }

              .title {
                position: absolute;
                top: -0.32rem;
                left: 50%;
                transform: translateX(-50%);
                font-size: 0.3rem;
                font-weight: bold;
                color: #fff;
                // text-shadow: 0rem .04rem .04rem rgba(0, 0, 0, 0.25);
                text-shadow: -0.01rem -0.01rem 0 #ff782f,
                  0.01rem -0.01rem 0 #ff782f, -0.01rem 0.01rem 0 #ff782f,
                  0.01rem 0.01rem 0 #ff782f;
              }
            }

            .backUls_box4_nr {
              width: 100%;
              min-height: 3rem;
              background: #ffffff;
              padding: 0.32rem 0.24rem 0.48rem 0.24rem;
              box-sizing: border-box;
              background: #ffffff;
              box-shadow: 0rem 0.08rem 0.12rem 0rem rgba(0, 0, 0, 0.05);
              border-radius: 0.16rem;
              position: relative;

              .backUls_box4_nr_list {
                // font-size: 0.26rem;
                // font-family: PingFang SC-Semibold, PingFang SC;
                // font-weight: 600;
                // color: #f97226;
                // line-height: 0.44rem;
                // text-align: center;
                margin-bottom: 0.32rem;
                ul {
                  width: 100%;
                  padding-left: 0.48rem;
                  box-sizing: border-box;

                  li {
                    width: 100%;
                    font-size: 0.26rem;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    color: #666666;
                    line-height: 0.44rem;
                    text-align: left;
                    list-style: disc;
                  }
                }
              }

              .backUls_box4_remarks {
                width: 100%;
                font-size: 0.26rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 0.44rem;
              }
            }
          }
        }
        .backUls_box5_back {
          // min-height: 3rem;
          margin-top: -22%;
          background: url("~@/assets/image/hodgepodge/back2.png") no-repeat;
          background-size: 100%;
          position: relative;
          padding-top: 2rem;
        }
        .backUls_box5 {
          width: 100%;
          padding: 0.32rem;
          padding-top: 0.8rem;
          box-sizing: border-box;
          background: #ff782f;

          .backUls_box5_content {
            width: 100%;
            background-size: 100%;
            width: 100%;
            padding: 0.32rem;
            padding-top: 0rem;
            box-sizing: border-box;
            border-image-source: url("~@/assets/image/hodgepodge/back3.png");
            border-image-slice: 84 10 10 10;
            border-image-width: 0.6rem 0.12rem 0.12rem 0.12rem;
            border-width: 0.12rem;

            .ulstitle {
              width: 6.0228rem;
              height: 0.43rem;
              margin: auto;
              img {
                width: 100%;
                margin-top: -0.85rem;
              }
            }
            /*  */
            .backUls_box5_nr {
              width: 100%;
              min-height: 3rem;
              background: #ffffff;
              padding: 0.32rem 0.24rem 0.48rem 0.24rem;
              box-sizing: border-box;
              background: #ffffff;
              box-shadow: 0rem 0.08rem 0.12rem 0rem rgba(0, 0, 0, 0.05);
              border-radius: 0.16rem;
              position: relative;

              .backUls_box5_nr_title {
                padding: 0.14rem 0.66rem;
                box-sizing: border-box;
                background: #ff9003;
                box-shadow: 0rem 0rem 0.14rem 0rem rgba(249, 118, 47, 0.3);
                border-radius: 0.62rem;
                border: 0.04rem solid #ffffff;
                font-size: 0.32rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #ffffff;
                display: inline-block;
                margin-bottom: 0.32rem;
              }

              .backUls_box5_nr_content {
                width: 100%;
                font-size: 0.28rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                color: #666666;
                line-height: 0.42rem;
                text-align: left;
                margin-bottom: 0.4rem;

                span {
                  color: #f97226;
                  font-weight: 600;
                }
              }

              .backUls_box5_nr_content:last-child {
                margin-bottom: 0rem;
              }

              .backUls_box5_nr_content_2 {
                width: 100%;

                ul {
                  width: 100%;
                  padding-left: 0.48rem;
                  box-sizing: border-box;

                  li {
                    width: 100%;
                    font-size: 0.28rem;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    color: #666666;
                    line-height: 0.42rem;
                    text-align: left;
                    margin-bottom: 0.2rem;
                    list-style: disc;

                    span {
                      color: #f97226;
                      font-weight: 600;
                    }

                    font {
                      color: #e80202;
                      font-weight: 600;
                    }
                  }
                }

                .a_view {
                  text-align: center;
                  font-size: 0.28rem;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #e80202;
                  text-decoration: underline;
                  margin-top: 0.2rem;
                  margin-bottom: 0.4rem;
                }
              }

              .backUls_box5_nr_content_2:last-child {
                margin-bottom: 0rem;
              }

              .backUls_box5_nr_content_3 {
                width: 100%;

                .backUls_box5_nr_content_3_view1 {
                  min-height: 2.82rem;
                  padding: 0.32rem;
                  box-sizing: border-box;
                  background: #fff6f1;
                  border-radius: 0.16rem;
                  border: 0.04rem solid #fed011;
                  position: relative;
                  margin-bottom: 0.48rem;

                  h1 {
                    width: 100%;
                    display: flex;
                    font-size: 0.28rem;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #f97226;
                    line-height: 0.36rem;

                    span {
                      color: #ff8f03;
                      margin-left: 0.2rem;
                      font-weight: 500;
                      font-size: 0.24rem;
                    }
                  }

                  ul {
                    width: 100%;
                    margin-top: 0.24rem;
                    padding-left: 0.48rem;
                    box-sizing: border-box;

                    li {
                      width: 100%;
                      font-size: 0.24rem;
                      font-family: PingFang SC-Semibold, PingFang SC;
                      color: #666666;
                      line-height: 0.28rem;
                      text-align: left;
                      list-style: disc;
                      font-weight: 400;
                      margin-bottom: 0.24rem;
                    }
                  }

                  .jinpai {
                    width: 1.66rem;
                    position: absolute;
                    right: -0.35rem;
                    bottom: 0;

                    img {
                      width: 100%;
                    }
                  }

                  .jiangbei {
                    width: 1.66rem;
                    position: absolute;
                    right: -0.35rem;
                    bottom: -0.1rem;

                    img {
                      width: 100%;
                    }
                  }
                }

                .backUls_box5_nr_content_3_view2 {
                  min-height: 1.96rem;
                  background: #fff6f1;
                  border-radius: 0.08rem;
                  border: 0.01rem solid #fa772f;
                  position: relative;
                  margin-bottom: 0;
                  display: flex;

                  .lists {
                    width: 2.44rem;
                    font-size: 0.24rem;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    color: #f97226;
                    line-height: 0.33rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-right: 0.01rem solid #fa772f;
                  }

                  .lists2 {
                    width: calc(100% - 2.44rem);

                    ul {
                      width: 100%;
                      height: 100%;
                      padding-left: 0.48rem;
                      box-sizing: border-box;
                      display: flex;
                      flex-wrap: wrap;
                      align-items: center;
                      align-content: center;

                      li {
                        width: 100%;
                        font-size: 0.24rem;
                        font-family: PingFang SC-Semibold, PingFang SC;
                        color: #666666;
                        line-height: 0.28rem;
                        text-align: left;
                        list-style: disc;
                        font-weight: 400;
                        margin-bottom: 0.24rem;
                      }
                    }
                  }
                }

                .bo_color {
                  background: #fffce8 !important;
                  border: 0.04rem solid #fed011 !important;
                }

                .bo_color2 {
                  background: #f9fcff !important;
                  border: 0.04rem solid #d1e1ee !important;
                }
                .bo_color3 {
                  background: #fff4ee !important;
                  border: 0.04rem solid #fa772f !important;
                }
              }

              .backUls_box5_nr_content_3:last-child {
                margin-bottom: 0rem;
              }
            }
          }
        }

        .backUls_box6 {
          width: 100%;
          padding: 0.32rem;
          padding-top: 1.32rem;
          box-sizing: border-box;
          background: #ff782f;
        }
      }
    }
    .fontBottom {
      height: 1.2rem;
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      // padding: 0.16rem 0.32rem 0.1rem 0.32rem;
      // box-sizing: border-box;
      // background: rgba(255, 129, 57, 0.28);
      // // background:#D0D0D0;
      // backdrop-filter: blur(.15rem);
      // -webkit-backdrop-filter: saturate(180%) blur(.15rem);
      background: url("~@/assets/image/icon/bottom_btn.png") no-repeat;
      background-size: cover;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        max-height: 0.9rem;
      }

      span {
        width: 100%;
        height: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        margin: auto;
        font-size: 0.48rem;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .datumBox {
    width: 100%;
    padding: 24px 0;
    box-sizing: border-box;

    .titleH1 {
      width: 100%;
      font-size: 18px;
      color: #ff5a25;
      font-weight: 600;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 11px;

      .right_icon {
        display: flex;
        align-items: center;
        div:nth-child(3) {
          display: inline-block;
          width: 4px;
          height: 4px;
          border-radius: 2px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
        div:nth-child(2) {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
        div:first-child {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
      }

      .left_icon {
        display: flex;
        align-items: center;
        div:first-child {
          display: inline-block;
          width: 4px;
          height: 4px;
          border-radius: 2px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
        div:nth-child(2) {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
        div:nth-child(3) {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
      }
    }

    .stepBox {
      width: 85%;
      margin: auto;
      position: relative;

      .stepUls {
        width: 100%;
        height: 30px;
        display: flex;

        .xian {
          width: 50%;
          height: 100%;
          position: relative;
        }

        .active {
          position: relative;
        }

        .active:after {
          content: ' ';
          width: 100%;
          height: 2.5px;
          background: #f5f5f5;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }

        .active2:after {
          content: ' ';
          width: 100%;
          height: 2.5px;
          background: #ff5a25;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }

      ul {
        width: 100%;
        height: 30px;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        li {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #ff5a25;
          position: relative;

          div {
            position: absolute;
            bottom: -10%;
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #cccccc;
          }
        }

        .active {
          width: 19px;
          height: 19px;
          border-radius: 50%;
          background: url('~@/assets/image/fusai/dui.png') no-repeat;
          background-size: 100%;
        }
      }
    }

    .stepText {
      width: 85%;
      margin: auto;
      height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      div {
        width: 33%;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #cccccc;
      }
      div:nth-child(1) {
        text-align: left;
      }
      div:nth-child(2) {
        text-align: center;
      }
      div:nth-child(3) {
        text-align: right;
      }

      .active {
        color: #de2810 !important;
      }
    }

    .datumCentent {
      width: 85%;
      margin: 20px auto 0;

      .tab {
        width: 100%;
        text-align: left;
        margin-bottom: 10px;

        .prompt {
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #4d4d4d;
          // margin-bottom: 12px;
          // padding-left: 13px;
          // box-sizing: border-box;
          display: flex;

          div {
            margin-right: 11px;
            text-align: center;
            line-height: 20px;
            color: #999999;
          }

          .highlight {
            color: #4d4d4d !important;
            position: relative;
          }

          .highlight:after {
            content: ' ';
            width: 90%;
            height: 1px;
            background: #4d4d4d;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
          }

          span {
            color: #de2810;
            margin-left: 5px;
          }
        }

        .lis {
          width: 100%;
          height: 34px;
          line-height: 34px;
          background: #f5f5f5;
          display: flex;
          justify-content: space-between;
          border-radius: 6px;

          .lisLife {
            display: flex;
            align-items: center;
            font-size: 13px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #4a4a4a;
            box-sizing: border-box;
            width: 90px;
            padding-left: 10px;
            img {
              width: 16px;
              height: 11px;
              margin-right: 5px;
            }
          }

          .lisRight {
            width: calc(100% - 95px);
            height: 100%;
            display: flex;
            input {
              font-size: 16px;
              width: 100%;
              height: 34px;
              padding-left: 3px;
              box-sizing: border-box;
              border: none;
              background: #f5f5f5;
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
            }
            input::-webkit-input-placeholder {
              color: #999999;
            }
            /* 使用webkit内核的浏览器 */
            input:-moz-placeholder {
              color: #999999;
            }
            /* Firefox版本4-18 */
            input::-moz-placeholder {
              color: #999999;
            }
            /* Firefox版本19+ */
            input:-ms-input-placeholder {
              color: #999999;
            } /* IE浏览器 */
          }
        }

        .promptInput {
          width: 100%;
          height: 45px;
          display: flex;
          align-items: center;
          padding-left: 15px;
          box-sizing: border-box;
          background: #f5f5f5;
          border-radius: 5px;
          margin-bottom: 15px;

          .right-btn {
            padding: 0 15px;
            text-align: right;
            font-size: 12px;
            color: #de2810;
            cursor: pointer;
          }

          input {
            flex: 1;
            height: 100%;
            font-size: 13px;
            font-family: PingFang SC-Regular, PingFang SC;
            background: #f5f5f5;
            border-radius: 5px;
            border: none;
            box-sizing: border-box;
          }

          input::-webkit-input-placeholder {
            color: #999999;
          }
          /* 使用webkit内核的浏览器 */
          input:-moz-placeholder {
            color: #999999;
          }
          /* Firefox版本4-18 */
          input::-moz-placeholder {
            color: #999999;
          }
          /* Firefox版本19+ */
          input:-ms-input-placeholder {
            color: #999999;
          } /* IE浏览器 */
        }

        .promptInput2 {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          // width: 75%;
          height: 34px;
          line-height: 34px;
          box-sizing: border-box;
          background: #f5f5f5;
          border-radius: 6px 6px 6px 6px;
          // margin-bottom: 12px;
          span {
            width: 100%;
            height: 100%;
          }
          .span_tw {
            color: rgb(153, 153, 153) !important;
          }
          .promptInputValue {
            width: 100%;
            height: 100%;
            padding-left: 13px;
            box-sizing: border-box;
            border: none;
            background: #f5f5f5;
            border-radius: 6px 6px 6px 6px;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
          }
        }

        .promptInput3 {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          background-color: #f7f8fa;
          height: 150px;
          position: relative;

          .wonderful {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #4d4d4d;

            img {
              width: 40px;
              height: 40px;
              border-radius: 50px;
              margin-bottom: 30px;
            }
          }

          .videoYulan {
            width: 100%;
            height: 100%;
            z-index: 999999;
            position: fixed;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;

            video {
              width: 80%;
              // object-fit: cover;
              height: 100%;
            }

            .guanbu {
              position: absolute;
              top: 5%;
              right: 5%;
              width: 20px;
              height: 20px;
              color: #fff;
              font-size: 12px;
              z-index: 999;
              border-radius: 50px;
              border: 1px solid #fff;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }

          .videoYulan2 {
            position: absolute;
            bottom: 3px;
            right: 0px;
            left: 0px;
            margin: auto;
            font-size: 12px;
            color: #ff5a25;
            text-align: center;
            width: 100%;
          }
        }

        .cell-item {
          margin-bottom: 15px;
          .tips {
            color: #de2810;
            font-size: 12px;
          }

          .promptInput {
            margin-bottom: 10px;
          }
        }
      }

      .tabTis {
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #4d4d4d;
        margin-bottom: 50px;

        img {
          width: 30px;
          height: 30px;
          margin-left: 10px;
        }
      }
      .tabTis_1 {
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #4d4d4d;
        line-height: 20px;
        // margin-bottom: 50px;

        img {
          width: 30px;
          height: 30px;
          margin-left: 10px;
        }
      }
      .view_guide {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff5a25;
        text-decoration: underline;
      }
      .but {
        min-width: 150px;
        height: 40px;
        display: inline-block;
        padding: 0 15px;
        background: url("~@/assets/image/but.png") no-repeat;
        background-size: 100% 100%;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        font-weight: bold;
        color: #fff;
        margin: auto;
        margin-top: 20px;
      }

      .but2 {
        width: 140px;
        height: 30px;
        text-align: center;
        font-size: 14px;
        color: #4d4d4d;
        margin: auto;
        margin-top: 10px;
      }
    }
  }
}
.newShortBox {
  padding: 12px 0 20px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 16px;

  .list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;

    .lis {
      width: 100%;
      margin-bottom: 10px;
    }

    .lis:last-child {
      margin-bottom: 0px !important;
    }

    .lisCenten {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .lisText2 {
      display: flex;
      justify-content: space-between;
      width: 65%;
      margin: auto;
      font-size: 12px;

      span {
        color: #ff5a25;
      }
    }

    .ulst {
      width: 100%;
      padding: 0 12px;
      margin: auto;

      ul {
        display: flex;
        justify-content: space-between;
        width: 100%;
        border-radius: 3px;

        li {
          width: 33.3%;
          text-align: center;
          font-size: 14px;
          padding: 5px;
        }
        li:nth-child(2) {
          width: 30% !important;
        }
      }

      ul:nth-child(1) {
        padding: 5px 0;
        background: #ff5a25;

        li {
          color: #fff;
        }
      }

      ul:nth-child(2) {
        background: #feffeb;
        margin-top: 10px;
        margin-bottom: 20px;

        li {
          color: #4e4e4e;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .lisText {
      padding: 0 12px;
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e4e4e;
      line-height: 1.5;
    }

    .but {
      width: 140px;
      height: 40px;
      background: url("~@/assets/image/but.png") no-repeat;
      background-size: 100%;
      text-align: center;
      line-height: 36px;
      font-size: 14px;
      font-weight: bold;
      color: #fff;
      margin: auto;
    }
  }
}
.show-link {
  color: #f97226;
  font-weight: 400 !important;
  text-decoration: underline;
}

.image-container {
  height: 78vh;
  overflow-y: auto;
}

.tables {
  position: relative;
  width: 100%;
  background-color: #fff;
  border-radius: 0.12rem;
  padding: 0.04rem;
  box-sizing: border-box;
  table {
    width: 100%;
    margin: 0 auto;
    border-collapse: separate;
    border-spacing: 0rem;
    border: 0.01rem solid #fa772f;
    font-size: 0.26rem;
    line-height: 0.42rem;
    font-family: PingFang SC-Semibold, PingFang SC;
    color: #666666;
    th {
      border: 0.01rem solid #fa772f;
      padding: 0.1rem;
      font-weight: 600;
    }
    td {
      border: 0.01rem solid #fa772f;
      padding: 0.1rem;
      vertical-align: middle;
    }
    span {
      // color: #e80202;
      font-weight: 600;
    }
  }
}
.contest_content {
  font-size: 0.28rem;
  font-family: PingFang SC-Semibold, PingFang SC;
  color: #f97226;
  text-align: left;
  line-height: 0.44rem;
  // font-weight: 600;
}

.bag_text {
  font-size: 0.28rem;
  font-family: PingFang SC-Semibold, PingFang SC;
  color: #666666;
  line-height: 0.44rem;
  text-align: left;
  background-color: #fff3e7;
  // background-color: #ffe5cc;
  padding: 0.12rem 0.14rem;
  border-radius: 0.06rem;
  margin-bottom: 0.15rem;
}
.font_red {
  color: #ff5a25;
  font-weight: 600;
}
.backUls_box4_nr_uls {
  width: 100%;
  padding-left: 0.24rem;
  box-sizing: border-box;
  margin-bottom: 0.32rem;

  .backUls_box4_nr_uls_list {
    width: 70%;
    height: 0.96rem;
    border-radius: 0rem 0rem 0rem 0rem;
    font-size: 0.26rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 0.3rem;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    // border:.01rem solid red;
    // text-align: right;
    padding-left: 30%;

    .select_bz {
      min-width: 1.58rem;
      padding: 0.06rem 0.36rem;
      box-sizing: border-box;
      background: #f97226;
      border-radius: 1.2rem;
      font-size: 0.26rem;
      line-height: 0.3rem;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      position: absolute;
      top: 50%;
      left: 0%;
      transform: translate(-0.25rem, -50%);
    }
  }

  .bz_color {
    background: #fff3e7;
  }
  .bz_color2 {
    background: #ffe5cc;
  }
  .ulstitle {
    width: 6.0228rem;
    height: 0.43rem;
    margin: auto;
    img {
      width: 100%;
      margin-top: -0.85rem;
    }
  }
}

.ulstitle {
  width: 6.0228rem;
  height: 0.43rem;
  margin: auto;
  img {
    width: 100%;
    margin-top: -0.85rem;
  }
}
.box_title {
  width: 6.0228rem;
  height: 0.43rem;
  box-sizing: border-box;
  margin: auto;
  position: relative;
  img {
    // height: 118.8px;
    // margin-top: -6.1%;
    // object-fit: none;
    width: 100%;
    margin-top: -0.85rem;
  }

  .title {
    margin-left: -3%;
    width: 62%;
    position: absolute;
    top: -0.5rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.4rem;
    // white-space: nowrap;
    font-weight: bold;
    color: #fff;
    // text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    text-shadow: -1px -1px 0 #ff782f, 1px -1px 0 #ff782f, -1px 1px 0 #ff782f,
      1px 1px 0 #ff782f;
  }
}
</style>
